import * as ActionTypes from '../actionTypes';
import apiActionCreator from '../../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../../common/util/errorUtils';
import {getUrlParameters} from '../../../common/util/urlParameters';
import * as MessageActions from '../../../common/messageBox/actions/actions';

export const getWtsParams = (params) => apiActionCreator({
  'endpoint': `/wts/params${getUrlParameters(params)}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_PARAMS,
    ActionTypes.FETCHED_WTS_PARAMS,
    [
      ActionTypes.FETCHED_WTS_PARAMS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const getWtsParamById = (paramId) => apiActionCreator({
  'endpoint': `/wts/params/${paramId}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_WTS_PARAM,
    ActionTypes.FETCHED_WTS_PARAM,
    [
      ActionTypes.FETCHED_WTS_PARAM_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const changeWtsParamSelected = (paramSelected) => ({
  'type': ActionTypes.CHANGE_WTS_PARAM_SELECTED,
  'payload': paramSelected,
});

export const createWtsParam = (data, areaId) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/wts/params',
      'authenticated': true,
      'types': [
        ActionTypes.CREATING_WTS_PARAM,
        [
          () => {
            dispatch(getWtsParams({'area': areaId}));
            return {'type': ActionTypes.CREATED_WTS_PARAM};
          },
          MessageActions.addMessageBoxInfo('Parámetro creado satisfactoriamente'),
        ],
        [
          ActionTypes.CREATED_WTS_PARAM_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': data,
    })
  );
};

export const updateWtsParam = (paramId, data, areaId) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/wts/params/${paramId}`,
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_WTS_PARAM,
        [
          () => {
            dispatch(getWtsParams({'area': areaId}));
            return {'type': ActionTypes.UPDATED_WTS_PARAM};
          },
          MessageActions.addMessageBoxInfo('Parámetro modificado satisfactoriamente'),
        ],
        [
          ActionTypes.UPDATED_WTS_PARAM_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'PUT',
      'contentType': 'application/json',
      'data': data,
    })
  );
};

export const deleteWtsParam = (paramId, areaId) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/wts/params/${paramId}`,
      'authenticated': true,
      'types': [
        ActionTypes.DELETING_WTS_PARAM,
        [
          () => {
            dispatch(getWtsParams({'area': areaId}));
            return {'type': ActionTypes.DELETED_WTS_PARAM};
          },
          MessageActions.addMessageBoxInfo('Parámetro eliminado satisfactoriamente'),
        ],
        [
          ActionTypes.DELETED_WTS_PARAM_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'DELETE',
    })
  );
};
